import React from 'react';
import { FDStack, FDTitleText } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const FormSection = ({ title, children }) => {
  return (
    <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
      {title ? <FDTitleText value={title} size={'lg'} /> : undefined}
      <FDStack direction={'column'} spacing={1}>
        {children}
      </FDStack>
    </FDStack>
  );
};
FormSection.defaultProps = {
  title: undefined,
};

FormSection.propTypes = {
  title: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
